(($, window, undefined) => {
    if (window.mg === undefined)
        window.mg = {};

    const _ = window.mg;

    const request = (type, url, data, suppressError, asAjax) => {
        const settings = {
            type: type
        };

        const props = {
            url  : url,
            data : data
        };

        if (typeof url === 'object') {
            $.extend(true, props, url);
        }

        $.extend(true, settings, props);

        if (asAjax === true) {
            if (suppressError === false && !settings.error) {

                settings.error = (jqXHR, textStatus, errorThrown) => {
                    if (jqXHR.status == 401) {
                        location.reload();
                        return;
                    }

                    if (props.url.indexOf('/Ping') > -1)
                        return; // We don't want the Ping to show an error

                    _.ui.errormodal({
                        html  : '<div>' + _.translations.SomethingWentWrongUnexpectedlyTryAgain + '.</div>',
                        title : _.translations.UnknownError
                    });
                };
            }

            return $.ajax(settings);
        } else {
            const onSuccess = (data, textStatus, jqXHR) => {
                // manipulate if need
                return $.Deferred().resolve(data, textStatus, jqXHR).promise();
            };

            const onError = (jqXHR, textStatus, errorThrown) => {
                if (suppressError === false) {
                    if (jqXHR.status == 401) {
                        location.reload();
                        return;
                    }

                    if (props.url.indexOf('/Ping') > -1)
                        return; // We don't want the Ping to show an error

                    _.ui.errormodal({
                        html  : '<div>' + _.translations.SomethingWentWrongUnexpectedlyTryAgain + '.</div>',
                        title : _.translations.UnknownError
                    });
                }

                return $.Deferred().reject(jqXHR, textStatus, errorThrown).promise();
            };
           
            return $.ajax(settings).then(onSuccess, onError);
        }
    };


    /*
    Examples:
    POST:
    const responsePost= await fetchAsync('https://httpbin.org/post', {'first_name':'Thomas','last_name':'Kristensen'});
    GET:
    const responseGet= await fetchAsync('https://httpbin.org/get', {'first_name':'Palle','last_name':'Hansen  æøåÆØÅ'},'GET');
     */

    async function fetchAsync(url, params, method, expectedResponseType) {
        method = !method ? 'POST' : method;
        var reqData = method == 'POST' ? new FormData() : new URLSearchParams();
        params && Object.entries(params).forEach(([k, v]) => reqData.append(k, v));
        url = method == 'POST' ? url : url += '?' + reqData.toString();
    
        //NOTICE: fetch() won't send cross-origin cookies unless you set the credentials init option (to include)
        const responsePromise = await fetch(url, {
            'method': method,
            'body': (method == 'POST' ? reqData : null)
        });
    
        if (!responsePromise.ok) {
            const response_error_txt = await responsePromise.text();
            throw new AjaxServerError(`Error processing ajax-request. URL|  [${url}]`, response_error_txt);
        }
    
        if (!expectedResponseType || expectedResponseType == 'json') {
            return responsePromise.json();
        } else {
            return responsePromise.text();
        }
    }

    class AjaxServerError extends Error {
        constructor(message, serverReponseBody) {
            super(message);
            this.name = "AjaxServerError";
            this.serverReponseBody = serverReponseBody;
        }
    }


    class Ajax {
        get(url, data, suppressError = false, asAjax = false) {
            return request('GET', url, data, suppressError, asAjax);
        }

        post(url, data, suppressError = false, asAjax = false) {
            return request('POST', url, data, suppressError, asAjax);
        }

        httpRequest(httpMethod, url, data, suppressError = false, asAjax = false) {
            return request(httpMethod, url, data, suppressError, asAjax);
        }

        async getAsync(url, data) {
            return await fetchAsync(url, data, 'GET')
        }

        async postAsync(url, data) {
            return await fetchAsync(url, data, 'POST')

        }
    }
    
    _.ajax = new Ajax();
})(jQuery, window);
